module.exports = __webpack_public_path__ + "img/gif1.cdb0d262.gif";